import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptFetchFailedAction = {
	type: 'TRANSCRIPT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptFetchFailedAction => ({
	type: 'TRANSCRIPT_FETCH_FAILED',
	payload,
});
